var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.email && !_vm.src ? 'Gravatar' : 'img',{tag:"span",staticClass:"logo",class:{inline: _vm.inline, square: _vm.square},attrs:{"email":_vm.email,"src":_vm.newSrc,"alt":_vm.newAlt,"title":_vm.newTitle}})}
var staticRenderFns = []

export { render, staticRenderFns }